<template>
  <a-modal title="素材关联" v-model="visible" @ok="handleOK">
    <a-form
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 12 }"
      labelAlign="left"
    >
      <a-form-item label="关联类型" class="link-material-form-item">
        <a-select v-model="type">
          <a-select-option value="name">按名称关联</a-select-option>
          <a-select-option value="custom">自定义关联</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        v-if="type === 'custom'"
        label="素材"
        class="link-material-form-item"
      >
        <a-checkbox-group
          v-model="checkedItems"
          class="link-material-checkbox-group"
        >
          <a-checkbox v-for="cb in checkboxes" :value="cb.id" :key="cb.id">
            {{ cb.name }}
          </a-checkbox>
          <a-empty
            v-if="!checkboxes.length"
            description="没有可关联的素材。"
            :image="defaultImage"
          />
        </a-checkbox-group>
      </a-form-item>
      <p v-else>本片段内具有相同名称的素材将被关联。</p>
      <p style="color: #f24">
        注意：素材关联仅关联本片段的图片、视频或容器内素材。
      </p>
    </a-form>
  </a-modal>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { Empty, message } from 'ant-design-vue';

export default {
  computed: {
    ...mapGetters(['selectedEffect', 'activeFragment']),
    ...mapState(['effects']),
    visible: {
      get() {
        return this.$store.state.linkMaterialVisible;
      },
      set(value) {
        this.$store.commit('handleLinkMaterialVisible', value);
      }
    },
    checkboxes() {
      const ret = [];
      if (this.selectedEffect) {
        this.activeFragment.effects.forEach(id => {
          if (id === this.selectedEffect.id) {
            return;
          }
          const effect = this.effects[id];
          switch (effect.type) {
            case 'image':
            case 'video':
              ret.push({ id: effect.id, name: effect.content.name });
              break;
            case 'group':
            case 'container':
            case 'textContainer': {
              const prevName = effect.content.name || (effect.type === 'textContainer' && effect.content.text) || 'container or group';
              effect.children.forEach(cid => {
                if (cid === this.selectedEffect.id) {
                  return;
                }
                const childEffect = this.effects[cid];
                if (childEffect.type === 'image' || childEffect.type === 'video') {
                  ret.push({
                    id: childEffect.id,
                    name: [prevName, childEffect.content.name].join('/')
                  });
                }
              });
            }
          }
        });
      }
      return ret;
    }
  },
  data() {
    return {
      type: 'name',
      checkedItems: [],
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE
    };
  },
  methods: {
    handleOK() {
      switch (this.type) {
        case 'name': {
          const obj = this.activeFragment.nameLinks || {};
          if (!(this.selectedEffect.content.name in obj)) {
            this.$set(this.activeFragment, 'nameLinks', {
              ...obj,
              [this.selectedEffect.content.name]: true
            });
          }
          if (this.selectedEffect.linkId) {
            this.selectedEffect.linkId = null;
          }
          break;
        }
        case 'custom': {
          if (this.checkedItems.length) {
            const linkId = ('' + Math.random()).slice(2);
            this.$set(this.selectedEffect, 'linkId', linkId);
            this.checkedItems.forEach(id => {
              const effect = this.effects[id];
              this.$set(effect, 'linkId', linkId);
            });
          } else {
            message.error('未选中任何素材。');
            return;
          }
          break;
        }
      }
      // clear previous linking if only one is remaining
      this.$store.dispatch('cleanupLinks');
      message.info('已添加素材关联。');
      this.visible = false;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        console.log('LinkMaterial visible');
        if (this.selectedEffect.linkId) {
          this.type = 'custom';
          this.checkedItems = [].concat.apply([], this.checkboxes.map(c => {
            const effect = this.effects[c.id];
            if (effect.linkId === this.selectedEffect.linkId) {
              return c.id;
            }
            return [];
          }));
        } else {
          this.type = 'name';
          this.checkedItems = [];
        }
      }
    }
  }
}
</script>
<style>
.link-material-form-item {
  margin-bottom: 14px;
}

.link-material-checkbox-group {
  display: block;
}

.link-material-checkbox-group .ant-checkbox-wrapper {
  display: block;
  margin: 9px 0 0;
}
</style>